import React from 'react';
import { useIntl } from '@/i18n/hooks/useIntl';
import { default as Msg } from '@/i18n/components/FormattedMessage';
import { createTelLinkHandler } from '@/utils/telLinkUtils';

export const CustomerService = () => {
  const { t } = useIntl();

  return (
    <>
      <div role='heading' aria-level={5} className='font-heading-xsmall-regular margin-bottom-m'>
        <Msg id='benefits.magentaTv.modal.customerService.headline' defaultMessage='Weitere Fragen?' />
      </div>
      <div className='margin-bottom-m'>
        <Msg
          id='benefits.magentaTv.modal.customerService.description'
          defaultMessage='Der Telekom-Kundenservice hilft dir gerne persönlich weiter'
        />
      </div>

      {/* problem phone number */}
      <div className='grid grid-flex grid-align-center'>
        <span className='is24-icon-telephone margin-right-s grid-item' style={{ color: '#2267e8' }} />
        <a
          href={`tel:${t({
            id: 'benefits.magentaTv.modal.customerService.problemPhoneNumber.number',
            defaultMessage: 'phone number',
          }).replaceAll(/[^0-9+]/g, '')}`}
          onClick={createTelLinkHandler(
            t({
              id: 'benefits.magentaTv.modal.customerService.problemPhoneNumber.number',
              defaultMessage: 'phone number',
            }),
          )}
          className='grid-item'
        >
          <Msg id='benefits.magentaTv.modal.customerService.problemPhoneNumber.number' defaultMessage='0800 33 01000' />
        </a>
      </div>
      <span style={{ marginLeft: '22px' }}>
        <Msg
          id='benefits.magentaTv.modal.customerService.problemPhoneNumber.text'
          defaultMessage='MagentaTV Störung & Login-Probleme'
        />
      </span>

      {/* service phone number */}
      <div className='grid grid-flex grid-align-center margin-top-m'>
        <span className='is24-icon-telephone margin-right-s grid-item' style={{ color: '#2267e8' }} />
        <a
          href={`tel:${t({
            id: 'benefits.magentaTv.modal.customerService.servicePhoneNumber.number',
            defaultMessage: 'phone number',
          }).replaceAll(/[^0-9+]/g, '')}`}
          onClick={createTelLinkHandler(
            t({
              id: 'benefits.magentaTv.modal.customerService.servicePhoneNumber.number',
              defaultMessage: 'phone number',
            }),
          )}
          className='grid-item'
        >
          <Msg id='benefits.magentaTv.modal.customerService.servicePhoneNumber.number' defaultMessage='0800 33 04000' />
        </a>
      </div>
      <span style={{ marginLeft: '22px' }}>
        <Msg
          id='benefits.magentaTv.modal.customerService.servicePhoneNumber.text'
          defaultMessage='MagentaTV Beratung'
        />
      </span>
    </>
  );
};
